import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model4InitialModel: ModelData = {
  name: 'Template 4 - Large Panel Door with Side Elements',
  modelId: 'model4',
  type: 'DOOR',
  description: '4-variant door with large fixed panels and single door opening',
  width: 3000,
  height: 2500,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  parameters: [
    // Frame profiles
    {
      positionId: 'top_frame_profile',
      type: 'PROFILE',
      width: 3000,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 1800,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 300,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2700, y: 2440, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2940, y: 0, z: 0 },
    },
    // Glass panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 1740,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: frameThickness, y: frameThickness, z: 0 },
    },
    {
      positionId: 'top_right_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 240,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: 1800, y: frameThickness, z: 0 },
    },
    {
      positionId: 'door_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 2200,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: 1800, y: 300, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 30,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 840, y: 980, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: -glassHingeWidth / 2,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 0,
              y: 2200 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: {
              x: 900 - glassLockWidth * 1.5,
              y: 2200 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },
    {
      positionId: 'far_right_glass_panel',
      type: 'GLASS',
      width: 240,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: ' ',
      materialId: null,
      isDouble: false,
      position: { x: 2700, y: frameThickness, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'single_door',
    totalDoorWidth: 900,
    individualDoorWidth: [900],
    totalHandles: 1,
    openingDirection: 'left_opening',
    hingePosition: 'left',
  },
}
